<template>
  <div>
    <v-card class="pt-4">
      <v-card-title>Nombre de rendez-vous par agence</v-card-title>
      <v-card-text class="pt-5">
        <v-btn
          class="mb-5"
          block
          @click="showDatepickerDialog"
          :loading="this.ui.loading"
        >
          <span v-if="start === end">Aujourd'hui</span>
          <span v-else
            >Du {{ start | moment("D MMMM Y") }} au
            {{ end | moment("D MMMM Y") }}</span
          >
        </v-btn>

        <div v-if="Object.keys(appointments).length">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Équipe</th>
                  <th class="text-left">Nombre de rendez-vous</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="team_name in Object.keys(appointments)"
                  :key="team_name"
                >
                  <td>{{ team_name }}</td>
                  <td>{{ appointments[team_name] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div
          v-else
          style="display: flex; justify-content: center; align-items: center"
          class="mt-5"
        >
          <MangoCaption
            >Aucun rendez-vous dans cette plage de dates.</MangoCaption
          >
        </div>
      </v-card-text>
    </v-card>

    <v-dialog :value="ui.datepickerDialog" persistent max-width="300">
      <v-date-picker v-model="ui.dates" range no-title>
        <v-spacer></v-spacer>
        <v-btn text @click="cancelDatepicker">Annuler </v-btn>
        <v-btn
          text
          color="primary"
          @click="submitDatepicker"
          :disabled="this.ui.dates.length !== 2"
          >Ok
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import api from "api";
import moment from "moment";

export default {
  data: () => ({
    appointments: {},
    start: moment().format("Y-MM-DD"),
    end: moment().format("Y-MM-DD"),
    ui: {
      loading: false,
      datepickerDialog: false,
      dates: [],
    },
  }),

  methods: {
    showDatepickerDialog() {
      this.ui.datepickerDialog = true;
    },

    cancelDatepicker() {
      this.ui.datepickerDialog = false;
      this.ui.dates = [];
    },

    submitDatepicker() {
      this.start = this.ui.dates[0];
      this.end = this.ui.dates[1];
      this.ui.datepickerDialog = false;
      this.ui.dates = [];
      this.refresh();
    },

    refresh() {
      this.ui.loading = true;
      api
        .get(`evision/stats?start=${this.start}&end=${this.end}`)
        .then((res) => {
          this.appointments = res.data.appointments;
          this.ui.loading = false;
        });
    },
  },

  mounted() {
    this.refresh();
  },
};
</script>
